import { useEffect, useState } from 'react';
import { isPwaApp } from '../config/appMode';
import { isStandalonePwa, PWA_UI_MEDIA_QUERIES } from '../utils/pwaUtils';

function readStandalonePwa() {
  return isPwaApp && isStandalonePwa();
}

/** True only in the installed PWA app window — not website or mobile browser tab. */
export function useStandalonePwa() {
  const [isStandalone, setIsStandalone] = useState(readStandalonePwa);

  useEffect(() => {
    const sync = () => setIsStandalone(readStandalonePwa());

    sync();
    window.addEventListener('resize', sync);

    const queries = [
      window.matchMedia(PWA_UI_MEDIA_QUERIES.standalone),
      window.matchMedia(PWA_UI_MEDIA_QUERIES.browser),
    ];
    queries.forEach((query) => query.addEventListener('change', sync));

    return () => {
      window.removeEventListener('resize', sync);
      queries.forEach((query) => query.removeEventListener('change', sync));
    };
  }, []);

  return isStandalone;
}
